module.exports = __webpack_public_path__ + "static/media/Header_img_small.b0bc1f2d.webp";